// src/client/components/projects/ProjectInfoCard.tsx
import { Card, CardContent } from '@/client/components/ui/card';
import { StatusBadge } from './StatusBadge';
import type { RouterOutputs } from '@/client/utils/trpc';

type Project = RouterOutputs['projects']['byId'];

export function ProjectInfoCard({ project }: { project: Project }) {
  const created = new Date(project.created_at).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
  return (
    <Card>
      <CardContent className="space-y-3 pt-4">
        <div>
          <p className="text-xs text-muted-foreground">Description</p>
          <p className="mt-1 text-sm">{project.description || '—'}</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground">Client</p>
          <p className="mt-1 text-sm font-medium">{project.client_name || '—'}</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground">Status</p>
          <div className="mt-1">
            <StatusBadge status={project.status} />
          </div>
        </div>
        <div>
          <p className="text-xs text-muted-foreground">Created</p>
          <p className="mt-1 text-sm">{created}</p>
        </div>
      </CardContent>
    </Card>
  );
}
